import React from "react";
import { Box, Button, Dialog, DialogContent, IconButton, Typography } from "@mui/material";
import { useTheme } from "@emotion/react";
import CloseIcon from "@mui/icons-material/Close";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import Ball from "./Ball";
import sagacoinImg from "../../../images/sega-coin.svg";

const ConfirmTicketDialog = ({
  open,
  onClose,
  selected,
  maxNumber,
  lottery,
  prizeLabel,
  ticketPriceLabel,
  buying,
  onConfirm,
}) => {
  const theme = useTheme();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="xs"
      BackdropProps={{
        style: { backdropFilter: "blur(5px)", backgroundColor: "rgba(0,0,0,0.4)" },
      }}
    >
      <DialogContent
        sx={{
          background: theme.palette.custom.black2_light2,
          textAlign: "center",
          py: 4,
        }}
      >
        <IconButton
          onClick={onClose}
          sx={{ position: "absolute", right: 8, top: 8, color: theme.palette.grey[500] }}
        >
          <CloseIcon />
        </IconButton>
        <Typography sx={{ color: theme.palette.custom.white_gray, fontWeight: 800, fontSize: "20px", mb: 2 }}>
          Confirm your ticket
        </Typography>
        <Box sx={{ display: "flex", justifyContent: "center", gap: 1.2, mb: 2, flexWrap: "wrap" }}>
          {selected?.map((n) => (
            <Ball key={n} num={n} max={maxNumber} size={48} />
          ))}
        </Box>
        <Typography sx={{ color: theme.palette.custom.white_gray, mb: 3 }}>
          <img src={sagacoinImg} alt="sc" style={{ width: 18, verticalAlign: "-3px", marginRight: 6 }} />
          {lottery?.name}
        </Typography>
        {prizeLabel && (
          <Box
            sx={{
              display: "inline-flex",
              alignItems: "center",
              gap: 0.8,
              background: "#00000033",
              border: `1px solid ${theme.palette.custom.yellow}55`,
              borderRadius: "10px",
              px: 1.6,
              py: 0.8,
              mb: 2,
            }}
          >
            <EmojiEventsIcon sx={{ fontSize: 18, color: theme.palette.custom.yellow }} />
            <Typography sx={{ color: theme.palette.custom.white_gray, fontSize: "13px" }}>
              If these numbers hit, you win{" "}
              <Box component="span" sx={{ color: theme.palette.custom.yellow, fontWeight: 800 }}>
                {prizeLabel}
              </Box>
            </Typography>
          </Box>
        )}
        {ticketPriceLabel && (
          <Typography sx={{ color: theme.palette.custom.white_gray, fontSize: "12px", opacity: 0.8, mb: 3 }}>
            {ticketPriceLabel} will be charged from your balance for this ticket.
          </Typography>
        )}
        <Button
          fullWidth
          disabled={buying}
          onClick={onConfirm}
          sx={{
            background: theme.palette.custom.green_green,
            color: "#fff",
            fontWeight: 800,
            borderRadius: "24px",
            py: 1.2,
            textTransform: "none",
            "&:hover": { opacity: 0.9, background: theme.palette.custom.green_green },
          }}
        >
          {buying ? "Processing..." : "Confirm Ticket"}
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default ConfirmTicketDialog;
